import * as Yup from 'yup';

const addressRegex = /^[\w\s]+,\s*[\w\s]+,\s*[A-Za-z]+,\s*\d+$/;

export const createTeamParams = Yup.object().shape({
    name: Yup.string().required('Please, provide the team name'),
    description: Yup.string().optional().nullable(),
    // location: Yup.string().required('Please, provide the team location'),
    shifts: Yup.array(Yup.string()).optional(),
});